import gameData from "../gameData.js";
import ACanvas from "../library/ExtendedObjects/ACanvas.js";
import AContainer from "../library/ExtendedObjects/AContainer.js";
import Utils from "../library/Utils.js";
import ABCyaPhaser, { Audio } from '@abcya/abcya_phaser';

export default class DragBug extends AContainer {
  constructor(scene, x, y, scale, anim, ind, jarInd) {
    super(scene, x, y);

    //patterns
    this.ind = ind;
    this.startX = 0;
    this.startY = y;
    this.endX = x;
    this.endY = y;
    this.startScale = scale;
    this.jarInd = jarInd;

    this.shadow = this.scene.addImage(0, 0, "shadow", this.scene.defaultAtlas, this);
    this.shadow.setScale(.4, .75);

    this.textureKey = Utils.GetRandomString();
    this.scene.textures.addImage(this.textureKey, this.scene.textures.get("fuzzbugSimple.png").getSourceImage());
    this.scene.add.existing(this);

    this.character = this.scene.addSpine(0, 0, "fuzzbugSimple" + this.jarInd, anim, true, (track) => { this.completeCheck(track); });
    this.character.spine.setScale(this.startScale);
    this.add(this.character.spine);
    this.setDepth(5);

    this.setLargeSize(true);

    this.on('dragstart', (pointer) => {
      this.isDragging = true;
      this.scene.killTween(this);

      this.character.play("Grabbed", true);
      this.direction = "down";

      let randSound = "pick_up" + Phaser.Math.Between(1, 10);
      this.scene.playSound(randSound, 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);

      this.scene.addTween(this.shadow, 250, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.None);

      this.disabled();
    });

    this.on('drag', (pointer, dragX, dragY) => {
      //console.log("dragging");
      this.x = dragX;
      this.y = dragY;
    });

    this.on('dragend', (pointer) => {
      this.scene.killTween([this, this.shadow, this.character.spine]);
      this.closestVial = null;

      this.scene.vials.vials.forEach((vial) => {
        //console.log(vial.bottomVials[0]);
        let questionLoc = Utils.StagePos(vial.bottomVials[0]);
        let img = vial.bottomVials[0].list[0];

        if (pointer.x >= questionLoc.x - (img.width / 2 + 10) && pointer.x <= questionLoc.x + (img.width / 2 + 10) && pointer.y >= questionLoc.y - img.height / 2 && pointer.y <= questionLoc.y + img.height / 2) {
          //console.log(vial.name + " vial");
          if (vial.startColor === this.startColor) this.closestVial = vial;
        }
      });

      this.scene.playSound("place_fb");

      if (this.closestVial && this.closestVial.bugCount < 9) {
        this.isCorrect = true;

        this.character.play("JumpFull", false);

        let min = this.closestVial.bottomVials[0].x - this.closestVial.bottomVials[0].list[0].width / 2 + 35;
        let max = this.closestVial.bottomVials[0].x + this.closestVial.bottomVials[0].list[0].width / 2 - 35;
        let between = Phaser.Math.Between(min, max);

        this.jarPos = { x: between, y: this.closestVial.bottomVials[0].y - this.closestVial.bottomVials[0].list[0].height / 2 + 40 }
        this.scene.addTween(this, 500, { x: between, y: this.closestVial.bottomVials[0].y - this.closestVial.bottomVials[0].list[0].height / 2 + 40 }, Phaser.Math.Easing.Quadratic.Out);
        this.scene.addTween(this.character.spine, 500, { scaleX: .15, scaleY: .15 }, Phaser.Math.Easing.Quadratic.Out,
          () => {
            this.setDepth(2);

            this.scene.addTween(this, 500, { y: this.closestVial.y + this.closestVial.bottomVials[0].list[0].height / 2 + this.closestVial.bottomVials[0].list[0].height * 1.5 - 142 }, Phaser.Math.Easing.Quadratic.In);
          });

        this.closestVial.bugCount++;
        gameData.totalBugCount++;

        gameData.vialBugs[this.closestVial.ind].push(this);

        if (gameData.totalBugCount >= gameData.totalBugs) this.scene.addDelay(1000, () => {
          //gameData.level = 12;
          //this.scene.playSound("instruct2");
          this.scene.goToQuestions();
        });
      } else {
        this.character.play("JumpFull", false);

        //this.enabled();

        let randSpot = Phaser.Math.Between(75, this.scene.mid.x * 2 - 75)
        this.scene.addTween(this, 1000, { x: randSpot, y: this.startY }, Phaser.Math.Easing.Quadratic.In);
        this.scene.addTween(this.shadow, 250, { scaleX: .8, scaleY: 1, delay: 850 }, Phaser.Math.Easing.Quadratic.Out);
      }
    });

    this.setInitParams();
  }

  setInitParams() {
    this.bodyData = { x: 0, y: 106, texture: "Base" };
    this.atlasSize = { width: 512, height: 512 };

    this.masks = [];
    this.numPaints = 0;

    this.stencilData = {
      Stencil1: { x: -10, y: -155 },
      Stencil2: { x: -40, y: -155 },
      Stencil3: { x: -52, y: -155 },
      Stencil4: { x: -16, y: -155 },
      Stencil5: { x: -104, y: -200 }
    };

    for (let i = 0; i < 5; i++) {
      this.stencilData["Stencil" + (i + 1)].x += this.bodyData.x;
      this.stencilData["Stencil" + (i + 1)].y += this.bodyData.y;
    }

    this.color = "";
    this.colorName = "";
    this.stencil = "";
    this.stencilColor = "";
    this.startColor = "";
    this.startColorName = "";

    this.blendTime = 500;
    this.isDragging = false;
    this.compareIDs = { question: null, answer: null };
    this.isPattern = false;
    this.isBlending = false;
    this.isCorrect = false;
    this.direction = null;
    this.patternID = null;
    this.delay = null;
    this.jarPos = { x: 0, y: 0 };
    this.outlinePos = { x: 0, y: 0 };
    this.isOff = false;
    this.isOrganizing = false;
    this.largest = false;
    this.smallest = false;

    this.character.setDefaultMix(this.blendTime / 1000);

    //play blinking animation
    this.character.playTrack("Blink", false, 1);

    this.weightedAnims = this.setWeightedResult(["right", "left", "idle"], [.2, .2, .6]);

    if (this.x <= 512) {
      this.x = this.startX = -100;
      this.direction = "right";
      this.character.play("WalkingRight", true);
    } else {
      this.x = this.startX = 1124;
      this.direction = "left";
      this.character.play("WalkingLeft", true);
    }

    this.scene.addDelay(Phaser.Math.Between(0, 1000), () => {
      this.delay = this.scene.addTween(this, 2500, { x: this.endX }, Phaser.Math.Easing.None,
        () => {
          if (this.direction === "right") {
            this.character.play("BreathRight", false);
          } else {
            this.character.play("BreathLeft", false);
          }
        });
    });
  }

  setSmallSize(enable) {
    this.smallWidth = 40;
    this.smallHeight = 40;

    this.input.hitArea.setSize(this.smallWidth, this.smallHeight);
    this.input.hitArea.setPosition(0, 0);

    if (enable) this.enabled();

    this.input.hitArea.centerX = 50;
    this.input.hitArea.centerY = 20;
  }

  setLargeSize(enable) {
    this.maxWidth = 100;
    this.maxHeight = 100;

    this.setSize(this.maxWidth, this.maxHeight);

    if (enable) this.enabled();

    this.input.hitArea.centerX = 50;
    this.input.hitArea.centerY = -15;
  }

  setSmallestSize() {
    this.input.hitArea.setSize(this.smallWidth, this.smallHeight);
    this.input.hitArea.setPosition(0, 0);

    this.input.hitArea.centerX = 50;
    this.input.hitArea.centerY = 30;
  }

  setLargestSize() {
    this.maxWidth2 = 75;
    this.maxHeight2 = 75;

    this.input.hitArea.setSize(this.maxWidth2, this.maxHeight2);

    this.input.hitArea.centerX = 50;
    this.input.hitArea.centerY = 0;
  }

  enabled(isClick) {
    if (!gameData.gameOver && !gameData.roundOver) {
      if (!this.input) {
        this.setInteractive({ cursor: 'Pointer' });
      }
      else if (this.input && !this.input.enabled) {
        this.setInteractive({ cursor: 'Pointer' });
      }

      // enableInputDebug(this);

      if (isClick) {
        if (this.largest === true) this.setLargestSize();
        else if (this.smallest === true) this.setSmallestSize();
        else this.setSmallSize();

        // remove the pointerup listener in case it has one
        this.off("pointerup");
        this.on("pointerup", () => {
          this.disabled();

          //console.log(gameData.level);
          if (gameData.level < 14) {
            this.closestVial.updateCounter();
            this.character.play("Cheer", true);
          }
          else if (gameData.level === 14 || gameData.level === 15 || gameData.level === 16 || gameData.level === 17) {
            if (this.ind === this.closestVial.directionalBug.ind) {
              this.character.play("Cheer", true);
              this.scene.disableBugs();
              gameData.transition = true;
              this.scene.playSound("correct_answer", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
            } else {
              this.scene.playIncorrectSound();
              this.character.play("Sad", true);
            }
          }
          else if (gameData.level === 18) {
            if (this.ind === this.closestVial.largest.ind) {
              this.character.play("Cheer", true);
              this.scene.disableBugs();
              gameData.transition = true;
              this.scene.playSound("correct_answer", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
            } else {
              this.scene.playIncorrectSound();
              this.character.play("Sad", true);
            }
          }
          else if (gameData.level === 19) {
            if (this.ind === this.closestVial.smallest.ind) {
              this.character.play("Cheer", true);
              this.scene.disableBugs();
              gameData.transition = true;
              this.scene.playSound("correct_answer", 1, false, Audio.LOCALIZATION_AUDIO_SPRITE);
            } else {
              this.scene.playIncorrectSound();
              this.character.play("Sad", true);
            }
          }
        });
      } else {
        //console.log(this.input);
        if (!this.input) {
          //console.log("enabling");
          this.scene.input.setDraggable(this);
        }
        else if (this.input) {
          //console.log("enabling");
          this.input.enabled = false;
          this.scene.input.setDraggable(this);
          this.input.enabled = true;
        }
      }
    }
  }

  disabled() {
    this.disableInteractive();
    this.scene.input.setDraggable(this, false);
  }

  tweenOut() {
    //console.log(this.closestVial.endX)
    this.scene.addTween(this, 1000, { x: "-=" + this.scene.scale.width }, Phaser.Math.Easing.Quadratic.In);
  }

  leaveScreen() {
    this.disabled();

    this.scene.killTween(this);
    if (this.delay) this.delay.remove();

    if (this.startX <= 512) {
      this.direction = "left";
      this.character.play("WalkingLeft", true);

      this.scene.addTween(this, 1500, { x: this.startX }, Phaser.Math.Easing.None);
    } else {
      this.direction = "right";
      this.character.play("WalkingRight", true);

      this.scene.addTween(this, 1500, { x: this.startX }, Phaser.Math.Easing.None);
    }
  }

  ////// ANIMATION FUNCTIONS //////

  completeCheck(obj) {
    //console.log("checking anim", obj);
    if (this.isBlending === false) {
      if (obj.animation !== null && obj.animation.name !== "Idle") this.animComplete(obj);
    } else {
      return;
    }
  }

  animComplete(obj) {
    //console.log(obj.animation.name);
    if (obj.animation.name === "Blink") {
      this.character.clearTrack(1);
      this.blinkah = this.scene.addDelay(Phaser.Math.Between(4000, 8000), () => { this.character.playTrack("Blink", false, 1); });
    }
    else if (obj.animation.name === "BreathRight" || obj.animation.name === "BreathLeft") {
      this.getWeightedResult(this.weightedAnims);
    }
    else if (obj.animation.name === "Falling" || obj.animation.name === "JumpFull") {
      // console.log(this.isCorrect, this.isDragging, this.isOrganizing);
      if (this.isCorrect) {
        this.scene.addTween(this.shadow, 250, { scaleX: 0, scaleY: 0 }, Phaser.Math.Easing.None);
        this.character.play("Idle", true);
      } else {
        if (this.isDragging) {
          this.isDragging = false;
          this.enabled();
          this.getWeightedResult(this.weightedAnims);
        }
        if (this.isOrganizing) {
          this.enabled(true);
        }
      }
    }
    else if (obj.animation.name === "Cheer") {
      this.character.play("Idle", true);

      if (gameData.level === 14) {
        // console.log("GO TO CHOOSE RIGHT!");
        this.scene.disableBugs();
        this.closestVial.alignBugs("right");
      }
      else if (gameData.level === 15) {
        // console.log("GO TO CHOOSE UP!");
        this.scene.disableBugs();
        this.closestVial.alignBugs("up");
      }
      else if (gameData.level === 16) {
        // console.log("GO TO DOWN!");
        this.scene.disableBugs();
        this.closestVial.alignBugs("down");
      }
      else if (gameData.level === 17) {
        // console.log("GO TO LARGEST!");
        this.scene.disableBugs();
        this.closestVial.alignBugs("largest");
      }
      else if (gameData.level === 18) {
        // console.log("GO TO SMALLEST!");
        this.scene.disableBugs();
        this.closestVial.alignBugs("smallest");
      }
      else if (gameData.level === 19) {
        // console.log("GO TO CUSTOMIZER!");
        this.closestVial.disableBugs();

        if (gameData.customFuzzbug) {
          this.scene.createTrueEnding();
        } else {
          this.scene.tweenOutGame();
        }
      }
    }
    else if (obj.animation.name === "WalkingLeft" || obj.animation.name === "WalkingRight") {
      if (gameData.level > 14 && !this.isOff) {
        this.character.play("Idle", true);
      }
    }
    else if (obj.animation.name === "Sad") {
      this.character.play("Idle", true);

      if (gameData.level >= 14 && gameData.level <= 19) {
        this.enabled(true);
      }
    }
  }

  setWeightedResult(list, weight) {
    // list: an array of objects
    // weight: an array of decimals whose total = 1
    // list and weight lengths must be the same
    let weighed_list = [];

    for (let i = 0; i < weight.length; i++) {
      let multiples = weight[i] * 100;

      for (let j = 0; j < multiples; j++) {
        weighed_list.push(list[i]);
      }
    }

    //returns a weighted array of 100 non random objects
    return weighed_list;
  }

  getWeightedResult(weighedList) {
    if (!this.isDragging && !this.isCorrect && !gameData.gameOver && !gameData.roundOver) {
      let randNum = Phaser.Math.Between(0, weighedList.length - 1);
      //console.log(randNum, weighedList[randNum]);

      if (weighedList[randNum] === "idle") {
        this.direction = "idle";
        this.character.play("Idle");
        this.weightDelay = this.scene.addDelay(Phaser.Math.Between(500, 2500), () => { this.getWeightedResult(weighedList); });
        return this.weightDelay;
      }
      else if (weighedList[randNum] === "right") {
        if (this.direction === "right") {
          this.character.play("IdleRight");
          this.weightDelay = this.scene.addDelay(Phaser.Math.Between(500, 2500), () => { this.getWeightedResult(weighedList); });
          return this.weightDelay;
        } else {
          this.direction = "right";
          this.character.play("WalkingRight", true);

          let dist = Phaser.Math.Between(this.x, this.scene.mid.x * 2 - 75);
          let delta = dist - this.x;
          let time;
          let reset = false;
          if (delta > 300) {
            time = 4500;
          } else if (delta > 200 && delta <= 300) {
            time = 3000;
          } else if (delta > 100 && delta <= 200) {
            time = 2000;
          } else if (delta > 35 && delta <= 100) {
            time = 1000;
          } else {
            reset = true;
          }

          if (!reset) {
            this.scene.addTween(this, time, { x: dist }, Phaser.Math.Easing.None,
              () => {
                this.character.play("IdleRight");
                this.weightDelay = this.scene.addDelay(Phaser.Math.Between(500, 2500), () => { this.getWeightedResult(weighedList); });
                return this.weightDelay;
              });
          } else {
            this.character.play("Idle");
            this.weightDelay = this.scene.addDelay(Phaser.Math.Between(500, 2500), () => { this.getWeightedResult(weighedList); });
            return this.weightDelay;
          }
        }
      }
      else if (weighedList[randNum] === "left") {
        if (this.direction === "left") {
          this.character.play("IdleLeft");
          this.weightDelay = this.scene.addDelay(Phaser.Math.Between(500, 2500), () => { this.getWeightedResult(weighedList); });
          return this.weightDelay;
        } else {
          this.direction = "left";
          this.character.play("WalkingLeft", true);

          let dist = Phaser.Math.Between(75, this.x);
          let delta = this.x - dist;
          let time;
          let reset = false;
          if (delta > 300) {
            time = 4500;
          } else if (delta > 200 && delta <= 300) {
            time = 3000;
          } else if (delta > 100 && delta <= 200) {
            time = 2000;
          } else if (delta > 35 && delta <= 100) {
            time = 1000;
          } else {
            reset = true;
          }

          if (!reset) {
            this.scene.addTween(this, time, { x: dist }, Phaser.Math.Easing.None,
              () => {
                this.character.play("IdleLeft");
                this.weightDelay = this.scene.addDelay(Phaser.Math.Between(500, 2500), () => { this.getWeightedResult(weighedList); });
                return this.weightDelay;
              });
          } else {
            this.character.play("Idle");
            this.weightDelay = this.scene.addDelay(Phaser.Math.Between(500, 2500), () => { this.getWeightedResult(weighedList); });
            return this.weightDelay;
          }
        }
      }
    }
  }

  ////// PAINT FUNCTIONS //////

  customizeUser() {
    this.stencil = gameData.fuzzStencil;
    this.color = gameData.fuzzColor;
    this.stencilColor = gameData.fuzzStencilColor;
    this.paintFuzzbug(gameData.fuzzStencilColor);
  }

  paintFuzzbug() {
    let colorCanvas = new ACanvas(this.scene, "colorCanvas" + this.ind, 258, 259);
    if (this.stencil != "") {
      colorCanvas.addSquare(this.stencilColor);
      colorCanvas.setComposition(ACanvas.compositions.DESTINATION_OUT);
      colorCanvas.addImage(this.stencilData[this.stencil].x, this.stencilData[this.stencil].y, this.stencil);
      colorCanvas.setComposition(ACanvas.compositions.DESTINATION_OVER);
    }
    colorCanvas.addSquare(this.color);

    let spineCanvas = new ACanvas(this.scene, "spineCanvas" + this.ind, this.atlasSize.width, this.atlasSize.height);
    spineCanvas.addImage(0, 0, this.textureKey);
    spineCanvas.setComposition(ACanvas.compositions.MULTIPLY);
    spineCanvas.context.drawImage(colorCanvas.context.canvas, this.bodyData.x, this.bodyData.y - 100);
    spineCanvas.setComposition(ACanvas.compositions.DESTINATION_IN);
    spineCanvas.addImage(0, 0, this.textureKey);

    // spineCanvas.saveToTexture("spineCnv"+this.ind, ()=>{
    //     console.log("creating image");
    //     this.scene.add.image(200,200, "spineCnv"+this.ind).setDepth(9999);
    // });

    let gl = this.scene.game.context;
    let texture = gl.createTexture();

    gl.bindTexture(gl.TEXTURE_2D, texture);
    gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA, gl.RGBA, gl.UNSIGNED_BYTE, spineCanvas.context.getImageData(0, 0, this.atlasSize.width, this.atlasSize.height));
    gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR);

    //console.log(this.character.spine.skeleton.skin.attachments);
    this.character.spine.skeleton.slots[6].attachment.region.texture.texture = texture;
    // this.character.spine.skeleton.skin.attachments[6]["images/Base"].region.texture.texture = texture;
  }

  ////// DESTRUCTION FUNCTIONS //////

  destroy() {
    this.shadow.destroy();

    this.scene.killTween(this);
    if (this.delay) this.delay.remove();

    this.disabled();

    if (this.scene != null) this.scene.textures.remove(this.textureKey);
    super.destroy();
  }

  cleanUp() {
    this.isBlending = false;
    this.isCorrect = false;
    this.direction = null;
    this.patternID = null;
    this.delay = null;

    if (this.blinkah) this.blinkah.destroy();

    this.destroy();
  }
}